import { useState, useContext, useEffect } from "react";
import { Footer, Header } from "../../components";
import "./styles.css";
import { Link, useLocation } from "react-router-dom";
import RentalItemCard from "./RentalItemCard";
import MyRentalCard from "./MyRentalCard";
import { AuthContext } from "../../context/AuthContext";
import { useTranslation } from "react-i18next";

export default function RentalsItems(props) {
  const userContextData = useContext(AuthContext);
  let { user_data, loginData, removeSpecificData } = userContextData;

  const { t } = useTranslation();
  const uselocation = useLocation();
  let rentalState = uselocation.state?.rentalState;
  const [rentals, setRentals] = useState(rentalState);

  useEffect(() => {
    user_data();
  }, []);

  return (
    <>
      <Header />
      <div className="container">
        <div className="row">
          <div className="col-md-12 mt-5 mb-3">
            <span
              className={rentals ? "DescriptionHeading" : "unActiveDescHeading"}
              onClick={() => setRentals(true)}
            >
              {t("My_Rentals")}
            </span>
            <span
              className={!rentals ? "ActiveReviewHeading" : "ReviewHeading"}
              onClick={() => setRentals(false)}
            >
              {t("My_Items")}
            </span>
            <Link
              to={rentals ? "/search" : "/Listanitem"}
              onClick={() => removeSpecificData()}
            >
              <button class="btn-custom btn-light rentalsBtn">
                {rentals ? "Rent new item?" : "List new item"}
              </button>
            </Link>

            <hr />
          </div>

          <div className="col-md-12">
            {rentals ? (
              <div className="col-md-12">
                <MyRentalCard {...props} loginData={loginData} />
              </div>
            ) : (
              <div className="col-md-12">
                <RentalItemCard {...props} loginData={loginData} />
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
{
  /* <div className="row">
  <div className="col-md-12">
    <h1 className="IdentityHeading mt-3">Rental History</h1>
  </div>
  <div>
    <div className="col-md-12">
      <div>
        {rentalHistory.map((OwnerData, index) => {
          return (
            <div className="col-md-12 mt-3 mb-5">
              <div className="row mainBoxShadow">
                <div className="col-md-3 col-12">
                  <img
                    src={Images.productImg}
                    alt="image"
                    className="imgOwnProduct"
                  />
                </div>
                <div className="col-md-3 col-12">
                  <span className="OwnerHeading">Owner: John Doe</span>
                  <br />
                  <span className="OwnerProduct">{OwnerData.name}</span>
                  <p className="OwnerHeading">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor consectetur adipiscing elit.
                  </p>
                  <p className="OwnerHeading">Category: Film & Photography</p>
                  <div>
                    <img src={Images.ratingIcon} alt="image" />
                    <span className="ratingOwerText">4.8</span>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="OwerlocationRight">
                    <img
                      className="locationIcon"
                      src={Images.locationIcon}
                      alt="image"
                    />
                    <span className="OwerlocationText">
                      Hong Kong - Kowloon - Yau Tsim Mong - Prince Edward
                    </span>
                    <p className="priceRentals">$350</p>
                    <p className="priceRentals">18/11/2021 - 23/11/2021</p>
                    <div className="btMainDivRentals">
                      <button
                        className="btnActiveRental"
                        style={{
                          backgroundColor:
                            OwnerData.statusItem == "Active Rental"
                              ? "#0BD437"
                              : "#FF3F64",
                        }}
                      >
                        {OwnerData.statusItem}
                      </button>

                      <button class="btn-custom btn-light">
                        Rental Details
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </div>
</div>; */
}
